import { render, staticRenderFns } from "./TheDebtObligation.vue?vue&type=template&id=5a0e5b67&"
import script from "./TheDebtObligation.vue?vue&type=script&lang=js&"
export * from "./TheDebtObligation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports